import { render, staticRenderFns } from "./FinanceAndDuban.vue?vue&type=template&id=b9f61132&scoped=true&"
import script from "./FinanceAndDuban.vue?vue&type=script&lang=js&"
export * from "./FinanceAndDuban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f61132",
  null
  
)

export default component.exports